var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "ResearchBriefs" } },
    [
      _c("appModal", {
        ref: "appModalRef",
        attrs: { countries: _vm.DBCountries }
      }),
      _c("appHeader", {
        attrs: { bgColor: "blue", page: "briefs" },
        on: { headerMenuClicked: _vm.menuClicked }
      }),
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          { staticClass: "main_inner" },
          [
            _vm._m(0),
            _vm._l(_vm.DBBriefs, function(briefObj, briefIndex) {
              return _c(
                "section",
                { staticClass: "main_section section_brief" },
                [
                  _c("div", { staticClass: "section_content" }, [
                    _c(
                      "a",
                      {
                        staticClass: "content_title",
                        attrs: { href: briefObj.link, target: "_blank" }
                      },
                      [_vm._v(_vm._s(briefObj.title))]
                    ),
                    _c("div", { staticClass: "content_date" }, [
                      _vm._v("Published " + _vm._s(briefObj.date))
                    ]),
                    _c("div", { staticClass: "content_details" }, [
                      _c(
                        "a",
                        {
                          staticClass: "content_image",
                          attrs: { href: briefObj.link, target: "_blank" }
                        },
                        [
                          briefObj.image == ""
                            ? _c("img", {
                                attrs: { src: "/images/visual-brief.png" }
                              })
                            : _c("img", { attrs: { src: briefObj.image } })
                        ]
                      ),
                      briefObj.expanded
                        ? _c("div", { staticClass: "content_desc" }, [
                            _vm._v(_vm._s(briefObj.description))
                          ])
                        : _c("div", { staticClass: "content_desc" }, [
                            _vm._v(_vm._s(_vm.truncate(briefObj.description)))
                          ])
                    ]),
                    briefObj.description.length > _vm.briefTextLimit
                      ? _c("div", { staticClass: "more_actionbar" }, [
                          _c(
                            "div",
                            {
                              staticClass: "actionbar_bt",
                              on: {
                                click: function($event) {
                                  briefObj.expanded = !briefObj.expanded
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  briefObj.expanded ? "Collapse" : "Read More"
                                )
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              )
            })
          ],
          2
        )
      ]),
      _c("appFooter")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "main_section" }, [
      _c("div", { staticClass: "section_content" }, [
        _c("h2", { staticClass: "text_subtitle" }, [_vm._v("More")]),
        _c("h1", { staticClass: "title_page text_title2" }, [
          _vm._v(
            "\n                        Research briefs\n                    "
          )
        ]),
        _c(
          "p",
          { staticClass: "text_p", staticStyle: { "margin-top": "24px" } },
          [
            _vm._v(
              "\n                        Here you will find the EUTO's latest research papers and briefs on the topics covered by the Atlas.\n                    "
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-670ea3c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670ea3c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/research-briefs/index.vue
// module id = v4z4
// module chunks = 8